import { motion } from "framer-motion"

const WIND = "https://static.lumi.new/4e/4e9e0d9a8c7f9be64af00b9607321bca.webp"

function Edition() {
  return (
    <section className="relative min-h-[80vh] w-full overflow-hidden md:min-h-screen">
      <motion.img
        src={WIND}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-[22%_center] md:object-[28%_center]"
        initial={{ scale: 1.12 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 3.2, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-black/55" />

      <div className="relative z-10 flex min-h-[80vh] w-full translate-y-[0.5cm] flex-col items-center justify-center px-8 py-32 pt-44 text-center md:min-h-screen md:py-28 md:pt-40">
        <motion.p
          className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          04
        </motion.p>
        <motion.h2
          className="font-sans-ui mt-10 text-xs tracking-[0.55em] text-stone-200 md:mt-8 md:text-sm"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, delay: 0.1 }}
        >
          CHAMPION EDITION 001
        </motion.h2>
        <motion.p
          className="font-display mt-8 text-5xl text-[#f7f1e6] md:mt-6 md:text-7xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.2 }}
        >
          冠軍限定香氛
        </motion.p>
        <motion.div
          className="mt-10 h-px w-16 bg-[#c4a574]/70"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.4 }}
        />
      </div>
    </section>
  )
}

export default Edition
